import {ISearchService} from './types';

/**
 * Import the appropriate search provider server here based on store configuration
 */

import Service from './services/Voyado';

const SearchService: ISearchService = {
  methods: {
    handleSearch: Service.methods.handleSearch,
    getFilters: Service.methods.getFilters,
    getProductResults: Service.methods.getProductResults,
    getCmsContent: Service.methods.getCmsContent,
    getSwatchData: Service.methods.getSwatchData,
  },
}

export default SearchService
